import ControlSidebar from './ControlSidebar';
import Layout from './Layout';
import PushMenu from './PushMenu';
import Treeview from './Treeview';
import DirectChat from './DirectChat';
import TodoList from './TodoList';
import Widget from './Widget';

export default class AdminLTE {
	constructor ($, pushMenuImages) {
		new ControlSidebar($);
		new Layout($); // değişiklik yapıldı.
		new PushMenu($, pushMenuImages); // değişiklik yapıldı.
		new Treeview($);
		new DirectChat($);
		new TodoList($);
		new Widget($);
	}
}
